import script from "./InputAttachmentWithPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputAttachmentWithPreview.vue?vue&type=script&setup=true&lang=ts"

import "./InputAttachmentWithPreview.vue?vue&type=style&index=0&id=6cc59603&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc59603"]])

export default __exports__